"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HALF_RATING_UPPER = exports.HALF_RATING_LOWER = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var VisuallyHidden_1 = __importDefault(require("../common/VisuallyHidden"));
var TypeSize_1 = require("../typography/TypeSize");
exports.HALF_RATING_LOWER = 0.3999;
exports.HALF_RATING_UPPER = 0.6001;
var Rating = function (props) {
    var classes = props.classes, iconColor = props.iconColor, iconSize = props.iconSize, inline = props.inline, total = props.total, value = props.value, otherProps = __rest(props, ["classes", "iconColor", "iconSize", "inline", "total", "value"]);
    var ratingElement = react_1.default.useRef(null);
    var _a = react_1.default.useState(), fontSize = _a[0], setFontSize = _a[1];
    var typeSize = TypeSize_1.getTypeSizeFromFontSize(fontSize);
    react_1.default.useLayoutEffect(function () {
        setFontSize(parseInt(window.getComputedStyle(ratingElement.current).getPropertyValue('font-size'), 10));
    }, []);
    return (react_1.default.createElement("span", __assign({ ref: ratingElement, className: getClassNames(classes, iconSize, inline, typeSize, value) }, otherProps),
        react_1.default.createElement(VisuallyHidden_1.default, null, value + " out of " + total),
        " ",
        getIcons(value, react_1.default.createElement(Icon_1.default, { name: "star", color: iconColor }))));
};
Rating.defaultProps = {
    total: 5
};
var getClassNames = function (classes, iconSize, inline, typeSize, value) {
    var _a;
    return classnames_1.default('fds-rating', (_a = {
            'fds-rating-half': showHalfRating(value),
            'fds-rating-inline': inline
        },
        _a["fds-icon-" + (iconSize && iconSize.trim().toLowerCase())] = iconSize,
        _a["fds-rating-inline-" + TypeSize_1.getNumber(typeSize)] = inline && typeSize,
        _a), classes);
};
var showHalfRating = function (value) {
    return ((value % 1 >= exports.HALF_RATING_LOWER) && (value % 1 <= exports.HALF_RATING_UPPER));
};
var getIcons = function (value, icon) {
    return Array.from(Array(Math.ceil(getIconCount(value))), (function (_, i) {
        return react_1.default.cloneElement(icon, { key: "icon_" + i });
    }));
};
var getIconCount = function (value) {
    if (value % 1 >= exports.HALF_RATING_LOWER) {
        return Math.ceil(value);
    }
    return Math.floor(value);
};
exports.default = Rating;
